import { render, staticRenderFns } from "./ManagementInfo.vue?vue&type=template&id=46306b2b&scoped=true"
var script = {}
import style0 from "./ManagementInfo.vue?vue&type=style&index=0&id=46306b2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46306b2b",
  null
  
)

export default component.exports